import getTheme from "./getTheme";
export default function color(color, theme) {
    if (typeof color === "string") {
        return color;
    }
    return getTheme(theme).colors[color[0]][color[1]];
}
//# sourceMappingURL=color.js.map